import { TransportInterface } from "../TransportInterface";

class ConsoleTransport implements TransportInterface {
  public style: string = "background: #008CFF; color: #ddd; font-size: 16px;";

  public log(message: string): Promise<any> {
    return new Promise((accept) => {
      console.log(`%c${message}`, this.style);
      return accept();
    });
  }

  public warn(message: string): Promise<any> {
    return new Promise((accept) => {
      console.warn(message);
      return accept();
    });
  }

  public debug(data: any, prefix: string): Promise<any> {
    return new Promise((accept) => {
      console.log(
        prefix.length === 0 ? `%cDebug Start` : `%c${prefix}`,
        this.style
      );
      console.log(data);
      console.log(
        prefix.length === 0 ? `%cDebug End` : `%c${prefix}`,
        this.style
      );
      return accept();
    });
  }

  public logError(err: any): Promise<any> {
    const errorObject = { ...err };

    if (errorObject?.action?.payload) {
      Object.keys(errorObject?.action?.payload || {}).forEach((key) => {
        if (key?.toLowerCase().includes("pass")) {
          errorObject.action.payload[key] = "******";
        }
      });
    }

    return new Promise((accept) => {
      console.log("%cError Start", this.style);
      console.error(err);
      console.log("%cError End", this.style);
      return accept();
    });
  }
}

export { ConsoleTransport };
